import React from 'react';
import styled from 'styled-components';
import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {isMobileOnly} from 'react-device-detect';
import SpanPckgNavPrice from '../common/price/SpanPckgNavPrice';

const EsReqProductinfoBlock = styled.div`
    .title {
        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
        color: #333333;
    }

    .line {
        width: 100%;
        height: 1px;
        border-bottom: solid 1px #111111;
    }

    .rqst-price {
        padding: 14px 0;
        font-size: 13px;
        font-weight: normal;
        color: #333333;
        text-align: center;

        .price {
            font-size: 14px;
            font-weight: 500;
        }
    }
`;

const EsReqProductBlock = styled.div`
    .info-block {
        height: 98px;
    }
    .img-block {
        ${isMobileOnly?`
        width: 98px;
        float: left;
        height: 98px;
        `:`
        margin-left: 20px;
        width: 100px;
        float: left;
        height: 100px;
        `};

        .pd_img {
            border-radius: 4px;
            min-width: 100%;
            height: 100%;
            vertical-align: middle;
            object-fit: cover;
        }
    }

    .list-item-conatiner {
        float: left;
        width: calc(88vw - 100px);
        padding-left: 10px;

        .name {
            font-size: 14px;
            font-weight: normal;
            line-height: 1.43;
            letter-spacing: normal;
            text-align: left;
            color: #333333;
            margin-bottom: 10px;

            max-height: 42px;
            display: -webkit-box;
            word-wrap: break-word;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            -o-text-overflow: ellipsis;
            text-overflow: ellipsis;
        }

        .option {
            font-size: 12px;
            font-weight: normal;
            line-height: 1.4;
            letter-spacing: normal;
            text-align: left;
            color: #666666;
            margin-bottom: 8px;
        }

        .num {
            font-size: 12px;
            font-weight: normal;
            line-height: 1.4;
            letter-spacing: normal;
            text-align: left;
            color: #999999;
            margin-bottom: 10px;
        }
    }

    .line_dot {
        width: 100%;
        height: 1px;
        border-bottom: dashed 1px #cccccc;
    }

    

    .price-block {
        .title {
            font-size: 13px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.46;
            color: #333333;
        }
        .price {
            font-size: 16px;
            font-weight: 500;
            line-height: 1.25;
            text-align: right;
            color: #111111;

            .delivery {
                font-size: 12px;
                font-weight: normal;
                line-height: 20px;
                color: #666666;
                margin-right: 10px;
            }
        }

        .won {
            font-size: 14px;
            font-weight: normal;
        }

        .red {
            color: #fd683a;
        }
    }

    .desc-block {
        padding: 20px;
        border-radius: 4px;
        background-color: #f4f4f4;

        font-size: 13px;
        font-weight: 400;
        line-height: 1.69;
        color: #333333;
    }
`;


const EsReqProductInfo = ({ esItem, onCloseClick }) => {

    const goToProduct = (prdct_id) => {
        let url = "/prod?prodid=" + prdct_id;
        var win = window.open(url, '_blank');
        win.focus();
    }

    const getPay = (item) => {
       /*  if (item.od_dlvy_pay_type === '025201') {
            let pay = item.od_it_pay_price - item.od_dlvry_fee;
            return pay;
        } */
        if(esItem&&(esItem[0].rqst_status === '050105' || esItem[0].rqst_status === '050111' || esItem[0].rqst_status === '050107' )) {
            return item.es_detail_pay_price;
        }

        return item.es_detail_prdct_price;
    }

    const validBottom = () => {
        if(esItem&&(esItem[0].rqst_status === '050105' || esItem[0].rqst_status === '050111' || esItem[0].rqst_status === '050107' )) {
            return true;
        }

        return false;
    }

    const getDeliveryText = (item) => {
        
        /* if(item.es_detail_dlvry_pay_type === '025201' || item.es_detail_dlvry_pay_type === '025202') {
            if(item.es_detail_dlvry_fee) {
                if(item.es_detail_dlvry_pay_type === '025202') {
                    return "예상 착불 배송비"
                } 
            } 
        } */
        
        return "배송비"
        
    }
    const getEsDeliveryPrice = (item) => {
        if (item.rqst_status === '050111' || item.rqst_status === '050105') {

            if(item.es_detail_dlvry_pay_type === '025201' || item.es_detail_dlvry_pay_type === '025202') {
                if(item.es_detail_dlvry_fee) {
                    if(item.es_detail_dlvry_pay_type === '025202') {
                        if(item.rqst_status === '050111' ) {
                            return (<div className="price  margin_t-5"><span className="delivery">착불 배송비</span>{Number(item.es_detail_dlvry_fee.toFixed(1)).toLocaleString()}<span className="won">원</span></div>)
                        } else {
                            return (<div className="price margin_t-5"><span className="delivery">착불 배송비</span>{Number(item.es_detail_dlvry_fee.toFixed(1)).toLocaleString()}<span className="won">원</span></div>)
                        }
                    } else {
                        if(item.rqst_status === '050111' ) {
                            return (<div className="price">{Number(item.es_detail_dlvry_fee.toFixed(1)).toLocaleString()}<span className="won">원</span></div>)
                        } else {
                            return (<div className="price">{Number(item.es_detail_dlvry_fee.toFixed(1)).toLocaleString()}<span className="won">원</span></div>)
                        }
                    }
                    
                } 
            }
            else {
                return (<div className="price won">무료배송</div>)
            }
        } 

        return (<div className="price gray">?<span className="won">원</span></div>)
    }

    const getEsDescBlock = (item) => {
        if(esItem&&esItem[0].rqst_status === '050105'&&item.es_detail_prdct_desc !== null && item.es_detail_prdct_desc !== undefined) {
            return (
                <div className="desc-block margin_b-20">{item.es_detail_prdct_desc}</div>
            )
        }

    }

    if(esItem === null || esItem === undefined) {
        return <div/>
    }

    return (
 
        <EsReqProductinfoBlock>
            <div className="title margin_b-20">견적 상품</div>
            {
                esItem.map((item, idx) => {
                    let key = idx;
                    return (
                    <EsReqProductBlock key={key}>
                        <div className="info-block clearfix">
                            <div className="img-block" onClick={()=>goToProduct(item.prdct_id)}>
                                <img className="pd_img " src={item.repr_img}></img>
                            </div>
                            <div className="list-item-conatiner">
                                <div className="name"onClick={()=>goToProduct(item.prdct_id)}>{item.prdct_nm}</div>
                                {item.opt_nm&&<div className="option" onClick={()=>goToProduct(item.prdct_id)}>{item.opt_nm}</div>}
                                <div className="num" onClick={()=>goToProduct(item.prdct_id)}><p><span>수량 : {item.qty}</span></p></div>
                            </div>
                        </div>
                        <div className="clearfix margin_b-10" >
                            <div style={{float: 'right', paddingTop: '0px'}}>
                                <SpanPckgNavPrice value={getPay(item)}
                                fontSize='18px' fontWeight='500' wonFontSize='18px' float='none' />
                            </div> 
                        </div>
                        {
                            validBottom()?
                            <div className="price-block">
                                <div className="line_dot"></div>
                                <div className="clearfix margin_t-20">
                                    <div className="title f-left">상품 금액</div>
                                    <div className="price f-right">{Number(item.es_detail_prdct_price.toFixed(1)).toLocaleString()}<span className="won">원</span></div>
                                </div>
                                <div className="clearfix margin_t-20">
                                    <div className="title red f-left">할인 금액</div>
                                    <div className="price red f-right">-{Number(item.es_detail_dscnt_price.toFixed(1)).toLocaleString()}<span className="won">원</span></div>
                                </div>
                                {
                                    item.es_detail_add_dscnt_price&&item.es_detail_add_dscnt_price*1>0 ?
                                    <div className="clearfix margin_t-20">
                                        <div className="title red f-left">추가 할인</div>
                                        <div className="price red f-right">-{Number(item.es_detail_add_dscnt_price.toFixed(1)).toLocaleString()}<span className="won">원</span></div>
                                    </div>
                                    :
                                    ''
                                }
                                <div className="clearfix margin_t-20 margin_b-20">
                                    <div className="title f-left">{getDeliveryText(item)}</div>
                                    <div className="price f-right">{getEsDeliveryPrice(item)}</div>
                                </div>
                                {getEsDescBlock(item)}
                                {(esItem.length - 1>idx)&&<div className="line margin_b-20"></div>}
                            </div>
                            
                            :
                            (esItem.length - 1>idx)&&<div className="line_dot margin_b-20"></div>
                        }
                        
                    </EsReqProductBlock>
                    )
                })
            }
            <div className="line" />
            <div className="rqst-price">
                <span>희망 견적 금액 : <span className="price">{Number(esItem[0].rqst_price.toFixed(1)).toLocaleString()}</span>원</span>
            </div>
            <div className="line" />
        </EsReqProductinfoBlock>
        
    );
};

export default EsReqProductInfo;
